import { ErrorHandler, onError } from '@apollo/client/link/error'
import { GraphQLError } from 'graphql'

export const logErrors: ErrorHandler = ({
  graphQLErrors,
  operation,
  networkError,
}) => {
  if (graphQLErrors) {
    const nonUserInputError = graphQLErrors.filter(
      error => error.extensions?.code !== 'BAD_USER_INPUT',
    )

    nonUserInputError.forEach((error: GraphQLError) => {
      console.warn('Error: GQL error', {
        error,
        response: error?.extensions?.response,
      })
    })
  }

  if (networkError) {
    const { operationName, getContext } = operation
    console.warn('Error: Network GQL error', {
      operationName,
      networkError,
      response: getContext?.()?.response,
    })
  }
}

export const errorLogger = onError(logErrors)
